import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const dateStringToRegexpConverter = (date: string | Date) => {
  let startDate: Date;

  if (typeof date === 'string') startDate = new Date(date);
  else startDate = date;

  return new RegExp(
    `${startDate.getDate().toString().padStart(2, '0')}/${(startDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${startDate.getFullYear()} ${startDate.getHours()}:${startDate.getMinutes()}`,
  ); // e.g. /17\/01\/2023 14:53/
};

export const formatDate = (date?: Date | null): string => {
  if (!date) return '';
  return dayjs(date).format('DD/MM/YYYY');
};

export const formatDateTimeLondon = (date?: Date | null): string => {
  if (!date) return '';
  const londonTime = dayjs(date).tz('Europe/London');
  const timezoneOffset = londonTime.format('Z');
  return `${londonTime.format('DD/MM/YYYY HH:mm')} ${timezoneOffset}`;
};

export const formatNoteDate = (date: Date): string => {
  return dayjs(date).format('Do MMM YYYY h:mma');
};

export const formatDateTimeLondonNoTz = (date?: string | Date | null): string => {
  if (!date) return '';
  return dayjs(date).tz('Europe/London').format('DD/MM/YYYY HH:mm');
};
